import { useMemo, memo } from "react";
import TGR from "../../../assets/tgr.PNG";
import { ownerData } from "../../../data/main.data";
import { useNavigate } from "react-router-dom";

function Navigation() {

  const navigate = useNavigate();

  const socialLinkElements = useMemo(() => {
    return ownerData.socials.map((data, index) => (
      <SocialLinks key={index} linkData={data} />
    ))
  }, [])

  return (
    <div className="border-y border-gray-500 w-full">
      <div className="py-2 px-3 md:px-10 flex justify-between items-center">
        <img src={TGR} alt="TGR Logo" className="w-10 h-10" onClick={() => navigate("/")}/>

        <div className="flex justify-between items-center gap-2">
          {socialLinkElements}
        </div>
      </div>
    </div>
  );
}

function SocialLinks({ linkData }: any) {
  const { svg, url } = linkData;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {svg}
    </a>
  );
}

// function LinkText({ linkData }: any) {
//   const {
//     name,
//     // isExternal, //is an external URL
//     page,
//     // url,
//   } = linkData;

//   return (
//     <Link to={page}>
//     <div className="underline underline-offset-2 hover:underline-offset-4 decoration-black flex justify-start items-center hover:cursor-pointer duration-300 hover:scale-105 ease-linear">
//       <p className="text-xl md:text-3xl font-light text-black">{name}</p>
//       <LinkIcon />
//     </div>
//     </Link>
//   );
// }

export default memo(Navigation);
